window.global ||= window
